import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pr0035',
    ecrans: ['00-2']
});
